var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"position_center"},[(_vm.msg === 'Verifying login. Please wait...')?_c('span',[_c('i',{staticClass:"el-icon-loading"}),_vm._v(" "+_vm._s(_vm.msg)+" ")]):(_vm.msg === 'error')?_c('span',[_vm._v(" "+_vm._s(_vm.msg)+". Redirecting to Login... ")]):_c('span',[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }